import React, { ReactNode } from 'react'
import { Dialog as MUIDialog, DialogContent } from '@mui/material'
import Button from '@ahha/stableComponents/Button/Button'
import { StyledContent, StyledDialog, StyledFooter, StyledHeader } from '@ahha/stableComponents/Dialog/styled'
import ImgButton from '@ahha/stableComponents/Button/ImgButton'

import { useI18n } from '@ahha/i18n/i18n'

import closeIcon from '@/assets/icons/common/close_icon.svg'

interface DialogProps {
  open: boolean;
  content: ReactNode;
  onClose: () => void;
  confirmText?: string;
  cancelText?: string;
  confirmAction?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  cancelAction?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  title?: string;
  width?: string;
  minWidth?: string;
  height?: string;
  minHeight?: string;
  padding?: string;
  disableConfirmButton?: boolean;
  showCloseButton?: boolean;
  className?: string;
  isSmallButton?: boolean;
  isRedButton?: boolean;
}

const Dialog = (props: DialogProps) => {
  const {
    open,
    content,
    onClose,
    confirmAction,
    confirmText,
    cancelAction,
    cancelText,
    disableConfirmButton = false,
    showCloseButton = false,
    title = '',
    width = '400px',
    height = '280px',
    padding = '1.5rem',
    minWidth,
    minHeight,
    className,
    isSmallButton = true,
    isRedButton = false,
  } = props
  const { t } = useI18n()

  if (!open) return null

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      className={`common-dialog__wrapper ${className}`}
      width={width}
      height={height}
      padding={padding}
      $minWidth={minWidth}
      $minHeight={minHeight}
    >
      {(showCloseButton || title) && (
        <StyledHeader>
          {title && <h5>{title}</h5>}
          {showCloseButton && (
            <ImgButton
              className="button--cancel"
              src={closeIcon}
              alt="Close Dialog"
              variant="transparent"
              onClick={onClose}
            />
          )}
        </StyledHeader>
      )}
      <DialogContent>
        <StyledContent className="common-dialog__content-wrapper">
          {content}
        </StyledContent>
      </DialogContent>
      {
        (confirmAction || cancelAction) && (
          <StyledFooter
            className={isSmallButton ? 'common-dialog__actions button--small' : 'common-dialog__actions button--large'}
          >
            {cancelAction && (
              <Button
                className="button--cancel"
                content={cancelText || t('common_cancel')}
                onClick={cancelAction}
                variant="transparent"
                size={isSmallButton ? 'sm' : 'lg'}
              />
            )}
            {confirmAction && (
              <Button
                className="button--confirm"
                content={confirmText || t('common_confirm')}
                onClick={confirmAction}
                disabled={disableConfirmButton}
                size={isSmallButton ? 'sm' : 'lg'}
                color={isRedButton ? 'error' : undefined}
              />
            )}
          </StyledFooter>
        )
      }
    </StyledDialog>
  )
}
export default Dialog
